import get from "lodash/get";
import { createSelector } from "reselect";

const userDetailsDomain = state => get(state, "api.loggedInUserDetails.data");
const userDetailsApiDomain = state => get(state, "api.loggedInUserDetails");
const userProfileDomain = state => get(state, "api.userProfileDetails", {});

export const currentPhoneNumberSelector = createSelector(
  userDetailsDomain,
  userDetails => get(userDetails, "telco_info.phone_no")
);

export const loggedInUserDetailsSelector = createSelector(
  userDetailsApiDomain,
  userProfileApi => get(userProfileApi, "data", {})
);

/**
 * Returns the user profile details
 */
export const userProfileDetailsSelector = createSelector(
  userProfileDomain,
  userProfileDetails => userProfileDetails.data || {}
);

export const makeSelectCurrentPhoneNumber = () => currentPhoneNumberSelector;
export const makeSelectLoggedInUserDetails = () => loggedInUserDetailsSelector;
export const makeSelectUserProfileDetails = () => userProfileDetailsSelector;
